import { useEffect, useState, useCallback } from "react";
import { useUrlQueryParams, useMediaSource } from "hooks";
import { usePodcastProvider, PodcastConfig, ModalType } from "components/podcast/PodcastProvider";
import { Player } from "react-media-player";

//ui
import { Box, Flex } from "@chakra-ui/react";
import { CustomPlayPause } from "components/podcast/CustomMediaPlayer";

interface ModalButtonsInterface {
  onOpen: () => void;
  podcastDetails?: PodcastConfig;
}

export function EpisodeDetailsButton({ onOpen, podcastDetails }: ModalButtonsInterface) {
  const { setModalType, setPlayingPodcast, setPlayPodcast, playingPodcast, playPodcast, podcastData } = usePodcastProvider();
  const [playerSrc, setPlayerSrc] = useState("");

  const { startPlaying } = useMediaSource({ podcastDetails });

  const showPlayer = playingPodcast && podcastDetails && playingPodcast.episode_number === podcastDetails.episode_number;

  const query = useUrlQueryParams();

  const currentEpisodeNumber = Number(query.get("episode_number"));

  const updateModalPodcast = useCallback(
    (podcast: PodcastConfig) => {
      setPlayingPodcast(podcast);
      setPlayPodcast(true);
    },
    [setPlayPodcast, setPlayingPodcast]
  );

  useEffect(() => {
    if (currentEpisodeNumber) {
      const queryPodcast = podcastData.find(({ episode_number }) => episode_number === currentEpisodeNumber);
      if (queryPodcast && playingPodcast && podcastDetails) {
        updateModalPodcast(queryPodcast);
        setModalType(ModalType.Details);
        onOpen();
      }
    }
  }, [currentEpisodeNumber, updateModalPodcast, podcastData, onOpen, setModalType, playingPodcast, podcastDetails]);

  const handlePlayPodcast = () => {
    if (podcastDetails) {
      updateModalPodcast(podcastDetails);
    }
  };

  useEffect(() => {
    if (showPlayer && playingPodcast?.audio_urls) {
      const source = startPlaying();
      setPlayerSrc(source);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPlayer, playingPodcast, playingPodcast?.audio_urls]);

  return (
    <Flex>
      {playPodcast && showPlayer ? (
        <Flex display={showPlayer ? "flex" : "none"}>
          <CustomPlayPause podcastDetails={podcastDetails} />
          <Box height="0px" width="0" display={playingPodcast?.audio_urls ? "flex" : "none"}>
            <Player src={playerSrc} vendor="audio" autoPlay={true} className="media-player"></Player>
          </Box>
        </Flex>
      ) : (
        <CustomPlayPause handlePlayPodcast={handlePlayPodcast} podcastDetails={podcastDetails} />
      )}
    </Flex>
  );
}
